module.exports = __webpack_public_path__ + "img/bleed.01857776.png";